
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class CurrentBacklogSubjectDetailForm extends Form {
	private static _instance = new CurrentBacklogSubjectDetailForm();
	studentId:Field = {
		name:'studentId'
		,controlType: 'Hidden'
		,label: 'studentId'
		,isRequired: true
		,valueType: 1
		,errorId: 'invalidId'
		,maxValue: 9999999999999
	};

	public static getInstance(): CurrentBacklogSubjectDetailForm {
		return CurrentBacklogSubjectDetailForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.controls.set('studentId', [Validators.required, Validators.max(9999999999999)]);
		this.fields.set('studentId', this.studentId);
		this.opsAllowed = {get: true, create: true, update: true, filter: true};
		this.keyFields = ["studentId"];
	}

	public getName(): string {
		 return 'currentBacklogSubjectDetail';
	}
}


export class CurrentBacklogSubjectDetailFd extends FormData {
	constructor(form: CurrentBacklogSubjectDetailForm, sa: ServiceAgent) {
		super(form, sa);
	}

	setFieldValue(name: 'studentId', value: string | number | boolean | null ): void {
		super.setFieldValue(name, value);
	}

	getFieldValue(name: 'studentId' ): string | number | boolean | null {
		return super.getFieldValue(name);
	}
}


export interface CurrentBacklogSubjectDetailVo extends Vo {
	studentId?: number, 
	usn?: string, 
	name?: string, 
	instituteId?: number, 
	numberOfAttempts?: number, 
	subjectCode?: string, 
	numberOfFailedAttempts?: number, 
	subjectId?: number, 
	pendingCredits?: number, 
	subjectName?: string
}
